import axios from "../authApi";

export const loginWithEmail = async (email: string) => {
  const betaEnv = import.meta.env.VITE_APP_BETA_ENV === "true";

  await axios.post("/auth/login-with-email", {
    email,
    betaEnv,
    codeLogin: true,
  });
};
